export default __webpack_public_path__ + "static/media/links-popover.7efc4158.png";